import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../Footer'

const IPhone = () => {
  return (
    <div>
      <Navbar />
      IPhone
      <Footer />

    </div>
  )
}

export default IPhone
